import { DeleteIcon, InfiniteTable } from '@/components/_common';
import {
  useDeletePartVehicleApplication,
  usePartVehicleApplications,
} from '@/core/domain/operational/PartVehicleApplications/PartVehicleApplications.hooks';
import { PartVehicleApplication } from '@/core/domain/operational/PartVehicleApplications/PartVehicleApplications.types';
import { Modal } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { useIntl } from 'react-intl';

interface Props {
  partId: number;
}

const PartApplicationRecordsList: React.FC<Props> = ({ partId }) => {
  const { data, isLoading } = usePartVehicleApplications(partId);
  const intl = useIntl();

  const removeMutation = useDeletePartVehicleApplication();

  const handleRemoveClick = (id: number) => {
    Modal.confirm({
      title: intl.formatMessage({ id: 'parts.application.modal.remove.title' }),
      content: intl.formatMessage({
        id: 'parts.application.modal.remove.content',
      }),
      onOk: async () => {
        await removeMutation.mutateAsync(id);
      },
      okType: 'danger',
    });
  };

  const columns: ColumnsType<PartVehicleApplication> = [
    {
      dataIndex: ['modelDTO', 'brand', 'name'],
      title: intl.formatMessage({ id: 'parts.application.modal.form.brand' }),
      ellipsis: true,
      width: 220,
    },
    {
      dataIndex: ['modelDTO', 'name'],
      title: intl.formatMessage({ id: 'parts.application.modal.form.model' }),
      ellipsis: true,
      width: 220,
    },

    {
      dataIndex: 'fromYear',
      title: intl.formatMessage({
        id: 'parts.application.modal.form.fromYear',
      }),
      ellipsis: true,
      width: 140,
    },
    {
      dataIndex: 'toYear',
      title: intl.formatMessage({ id: 'parts.application.modal.form.toYear' }),
      ellipsis: true,
      width: 140,
    },
    {
      dataIndex: 'actions',
      title: intl.formatMessage({ id: 'commons.list.header.action' }),
      render: (_, record) => (
        <DeleteIcon onClick={() => handleRemoveClick(record.id)} />
      ),
      ellipsis: true,
      width: 100,
      align: 'right',
      fixed: 'right',
    },
  ];

  return (
    <InfiniteTable
      dataSource={data?.data}
      columns={columns}
      pagination={false}
      loading={isLoading}
      rowKey={(row) => row.id}
    />
  );
};

export default PartApplicationRecordsList;
